__turbopack_context__.v({
  "root": "Divider-module-scss-module__txY4iW__root",
});
